import React from 'react';
import {connect} from 'react-redux';

import {AppState} from "@Redux/store";
import {Dispatch} from "@Redux/type";
import Repeater from "@Utils/Repeater";
import OldCampaign from "@Components/survey/OldCampaign/OldCampaign";
import {CampaignView} from "@Selectors/tool/survey/view/CampaignView";
import {Row} from "reactstrap";
import {OldCampaignsSelector} from "@Selectors/tool/survey/OldCampaignsSelector";
import { FormattedMessage } from 'react-intl';

const OldCampaigns: React.FC<AvailableCampaignsToAnswerProps> = ({campaigns}) => {
  if(campaigns.length === 0) return <></>;

  return <section className="m-5">
    <h2><FormattedMessage id={'survey.campaign.index.old.title'} /></h2>
    <Row className="content justify-content-center">
      <Repeater data={campaigns} indexPrefix='folder'>
        {
          (item: CampaignView) => <OldCampaign campaign={item}/>
        }
      </Repeater>
    </Row>
  </section>;
};

const mapStateToProps = (state: AppState) => ({
  campaigns: OldCampaignsSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(OldCampaigns);

type AvailableCampaignsToAnswerProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
